import { createFeatureSelector, createSelector } from '@ngrx/store';
import { APPLICATION_FEATURE_KEY, ApplicationState } from './application.reducer';

// Lookup the 'Application' feature state managed by NgRx
export const getApplicationState = createFeatureSelector<ApplicationState>(APPLICATION_FEATURE_KEY);
export const getAccessToken = createSelector(getApplicationState, state => state.accessToken);
export const getApplication = createSelector(getApplicationState, state => state.application);
export const getCorpPassCode = createSelector(getApplicationState, state => state.corppassCode);
export const getRetrieve = createSelector(getApplicationState, state => state.retrieve);
